import { call, put, select, takeEvery } from 'redux-saga/effects'

import { BuilderSteps, EventTrackingNames } from '@enums'
import { IHateoasLink } from '@store'
import { trackEvent } from '@store/analytics'
import { selectAuthToken } from '@store/auth'
import {
  finalize,
  FinalizeCampaignActionTypes,
  finalizeError,
  finalizeSuccess,
  saveCampaign,
  selectFinalizeLink,
} from '@store/campaigns'
import {
  selectHasBrandPartnershipHandle,
  selectRequestedSocialSubmissionTypes,
} from '@store/drafts'
import { fetchMeRequest, shouldShowCampaignCreationPrompt } from '@store/me'
import { setUIFlag, setUIFlagData, UIFlag } from '@store/ui'
import { networkRequest } from '@utils'

export function* handleFinalize(action: ReturnType<typeof finalize>) {
  try {
    const { campaignId, campaignType, params } = action.payload
    const { payment_details, ...finalizeDetails } = params
    const { history, redirect, toast } = action.meta

    yield put(saveCampaign(BuilderSteps.SUBMIT))

    const authToken: string = yield select(selectAuthToken)
    const finalizeLink: IHateoasLink = yield select(selectFinalizeLink, campaignId)

    yield call(
      networkRequest,
      finalizeLink.method,
      finalizeLink.href,
      {
        ...finalizeDetails,
        payment_details,
      },
      authToken,
    )

    const paidPartnershipTag = yield select(selectHasBrandPartnershipHandle, campaignId)
    const requestedSocialSubmissionTypes = yield select(
      selectRequestedSocialSubmissionTypes,
      campaignId,
    )
    yield put(
      trackEvent(EventTrackingNames.CampaignBuilderSubmitCampaign, {
        brief_id: campaignId,
        brief_type: campaignType,
        paid_partnership_tag: paidPartnershipTag,
        requested_social_submission_types: requestedSocialSubmissionTypes,
      }),
    )

    yield put(finalizeSuccess(campaignId, { toast }))
    yield put(fetchMeRequest())

    const showCampaignCreationPrompt = yield select(shouldShowCampaignCreationPrompt)
    if (showCampaignCreationPrompt) {
      yield put(setUIFlag(UIFlag.SHOW_CAMPAIGN_CREATION_CONFIRMATION_MODAL))
      yield put(
        setUIFlagData({
          flag: UIFlag.SHOW_CAMPAIGN_CREATION_CONFIRMATION_MODAL,
          data: {
            paymentMethod: payment_details?.payment_type,
          },
        }),
      )
    }

    yield call(history.push, redirect)
  } catch (error) {
    yield put(finalizeError(error))
  }
}

export function* watchFinalizeRequest() {
  yield takeEvery(FinalizeCampaignActionTypes.FINALIZE_REQUEST, handleFinalize)
}
